module.exports = __webpack_public_path__ + "img/SmartDelta App Logo.fa83c38d.png";